export default __webpack_public_path__ + "static/media/016-dynamite.cc3043e2.png";